module.exports = __webpack_public_path__ + "static/media/icon-id-card-red.fce7c300.svg";